'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Misc = require('utils/misc');
var Utils = require('components/common/utils');

var MapToolbarView = Marionette.ItemView.extend({
    template: require('components/devices/templates/map/map_toolbar'),

    ui: {
        btnRefresh: '#js-refresh',
        btnAutoRefresh: '#js-toggle-auto-refresh',
        ddlField: 'select#df-field',
        spinner: '#js-refresh > i',
    },

    events: {
        'hide.bs.select select.js-filter-select': 'updateValueSelect',
        'click @ui.btnRefresh': 'refreshMap',
        'click @ui.btnAutoRefresh': 'toggleAutoRefresh',
        'click #js-toggle-heatmap': 'toggleHeatmap',
        'click #js-toggle-label': 'toggleLabel',
        'click #js-toggle-icons': 'toggleIcons',
        'click #js-zoom-in': 'zoomIn',
        'click #js-zoom-out': 'zoomOut',
        'click #js-zoom-reset': 'zoomReset',
        'click .js-show-filter': 'showFilter',
        'click .js-reset-filter': 'resetFilter',

        'mouseenter [data-toggle="tooltip"]': Utils.showTooltip,
    },

    initialize: function (options) {
        this.mapView = options.mapView;
        var config = options.config;

        this.field_select = config.addr;

        this.isAutoRefresh = config.autoRefresh == 'true';
        this.isHeatmapShown = config.heatmap == 'true';
        this.isLabelsShown = config.labels == 'true';
        this.isIconsShown = config.icons == undefined || config.icons == 'true';
    },

    serializeData: function () {
        function isFieldValid(item) {
            if (
                Misc.countWhere(Consts.FieldInfo.NoFilter, function (x) {
                    return x == item.id;
                })
            ) {
                return false;
            }
            return item.unit != 'Uhr' && item.format != 't##.##.';
        }

        var fields = Misc.selectWhere(
            AppState.uniqueFields((this.mapView.filterObj || {}).category, Consts.FieldGroup.Data),
            function (item) {
                return isFieldValid(item);
            }
        );
        fields.unshift({ id: '--', name: '--' });

        if (
            _.find(
                fields,
                function (e) {
                    return e.id == this.field_select;
                },
                this
            ) == undefined
        ) {
            this.field_select = undefined;
        }

        var data = {
            fields: fields,
            field_select: this.field_select != '--' ? this.field_select : undefined,

            autoRefresh: this.isAutoRefresh,
            heatmap: this.isHeatmapShown,
            labels: this.isLabelsShown,
            icons: this.isIconsShown,
        };

        return data;
    },

    updateValueSelect: function () {
        if (this.field_select == this.ui.ddlField.val()) {
            // nothing changed
            return;
        }

        this.field_select = this.ui.ddlField.val();
        if (this.field_select == '--') {
            this.field_Select = undefined;
            this.isHeatmapShown = false;
            this.isLabelsShown = false;
            this.isIconsShown = true;
        }

        this.mapView.refreshMap(undefined, false);
        this.render();
    },

    refreshMap: function () {
        this.mapView.refreshMap();
    },

    toggleAutoRefresh: function () {
        this.isAutoRefresh = !this.isAutoRefresh;

        this.mapView.toggleAutoRefresh();
        this.render();
    },

    toggleHeatmap: function () {
        this.isHeatmapShown = !this.isHeatmapShown;
        this.mapView.refreshMap();
    },

    toggleLabel: function () {
        this.isLabelsShown = !this.isLabelsShown;
        this.mapView.refreshMap();
    },

    toggleIcons: function () {
        this.isIconsShown = !this.isIconsShown;
        Misc.setDisabled('#js-toggle-label', !this.isIconsShown);
        this.mapView.refreshMap();
    },

    zoomIn: function () {
        this.mapView.zoomIn();
    },

    zoomOut: function () {
        this.mapView.zoomOut();
    },

    zoomReset: function () {
        this.mapView.zoomReset();
    },

    showFilter: function (e) {
        this.mapView.showFilter(e);
    },

    resetFilter: function (e) {
        this.mapView.resetFilter(e);
    },

    selectedField: function () {
        var selected = this.ui.ddlField.val();
        return selected == '--' ? undefined : selected;
    },

    indicateRefresh: function (isRefreshing) {
        if (isRefreshing) {
            this.ui.spinner.addClass('fa-spin');
        } else {
            this.ui.spinner.removeClass('fa-spin');
        }
        Misc.setDisabled('#js-refresh', isRefreshing);
    },

    onShow: function () {
        this.initControls();
        $('div.buttongroup button').tooltip({
            html: true,
            container: 'body',
        });
    },

    onRender: function () {
        this.initControls();
    },

    initControls: function () {
        Misc.initSelectPicker({
            selector: '.js-filter-select',
            class: 'width-150',
        });
    },
});

module.exports = MapToolbarView;
